import React from 'react';
import useEllipsisDisplay from '../../util/hooks/useEllipsisDisplay';
import Tooltip from '.';

/**
 *
 * HOC component to render tooltip around any children
 * Only displays tooltip if ellipsis are shown
 */
const withTooltip =
  <P extends {}>(WrappedComponent: React.ComponentType<P>) =>
  (props: any) => {
    const { title } = props;
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const { tooltipDisplay, target } = useEllipsisDisplay({
      title,
    });
    const handleTooltipOpen = () => {
      setTooltipOpen(true);
    };
    const handleTooltipClose = () => {
      setTooltipOpen(false);
    };

    return (
      <Tooltip
        open={tooltipDisplay && tooltipOpen}
        text={title}
        onOpen={handleTooltipOpen}
        onClose={handleTooltipClose}
        placement="top-start"
      >
        <div ref={target}>
          <WrappedComponent {...props} />
        </div>
      </Tooltip>
    );
  };

export default withTooltip;
